export default "__VITE_ASSET__DuxGfXdX__"